import React from 'react';
import { Dropdown } from '@instinet-analytics/semantic-ui-components';
import {
    EnumMap,
    enumMapToDropdownOptions,
} from '@instinet-analytics/core-lib';

interface EnumControlProps {
    className?: string;
    enumMap: EnumMap;
    value: string;
    onChange: (value: string) => void;
}

export default function EnumControl(props: EnumControlProps) {
    const { className, enumMap, value, onChange } = props;

    const options = enumMapToDropdownOptions(enumMap);

    return (
        <Dropdown
            className={className}
            options={options}
            value={value}
            onChange={onChange}
        />
    );
}
